import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";

import Tabs from "@components/spotprofile/tabs";
import { MainLayout } from "@layouts/MainLayout";
import shadow from "@assets/spot-title-shadow.png";
import { useTranslation } from "@hooks/useTranslation";
import { useMobileDetect } from "@hooks/useMobileDetect";
import { useEffect, useState } from "react";
import curve from "../../public/images/footer-curve.svg";
import TabsSearch from "@components/spotprofile/tabs-search";

export default function SpotProfileLayout({
  children,
  cityName,
  backgroundImage,
  meta,
  search,
}: {
  children: React.ReactNode;
  cityName: string;
  backgroundImage: string;
  meta: {
    title: string;
    description: string;
  };
  search: boolean;
}) {
  const { isMobile } = useMobileDetect();
  const { t } = useTranslation();
  const router = useRouter();
  const [isInMap, setIsInMap] = useState(false);

  useEffect(() => {
    if (router.pathname.endsWith("map") && isMobile()) {
      setIsInMap(true);
    } else {
      setIsInMap(false);
    }
  }, []);

  return (
    <MainLayout>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <section className="relative flex flex-col items-center justify-between pb-4 md:pb-0 pt-24 md:h-[40vh]">
        <Image
          src={backgroundImage}
          alt={cityName}
          className="absolute object-cover w-full h-full -z-10"
          quality={80}
          fill
        />
        <div className="flex flex-col items-center w-full h-full gap-1 pb-2 md:justify-center md:pt-4 md:pb-0">
          <h1 className="font-semibold text-center uppercase md:text-2xl text-primary-color">
            {t("spotprofile.title")}
          </h1>
          <h1 className="text-3xl font-bold text-center text-white uppercase md:text-7xl">
            {cityName}
          </h1>
          <Image
            src={shadow}
            alt=""
            className="absolute bottom-0 lg:-bottom-12 left-0 w-full h-3/5 lg:h-4/5 pb -z-[1]"
          />
        </div>
      </section>
      <section
        className={"bg-black text-white " + `${isInMap ? "pb-52" : "pb-32"}`}
      >
        <div className="lg:hidden">{!isInMap && ( (!search && <Tabs />) || (search && <TabsSearch />) )}</div>

        <div>{children}</div>
      </section>
      <section className="h-20 mb-10">
      {isMobile() && (
        <Image className="object-cover w-full" src={curve} alt={""} />
      )}
      </section>
    
    </MainLayout>
  );
}
